module.exports = __webpack_public_path__ + "static/media/hall-CSC.370d9d59.svg";